import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";

import { loginRequest } from "../authConfig";
import WorkspaceLoading from "./WorkspaceLoading";

const RegisterRedirect = () => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const startedRef = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isAuthenticated || startedRef.current || inProgress !== InteractionStatus.None) return;

    startedRef.current = true;
    instance.loginRedirect({
      ...loginRequest,
      prompt: "create",
      redirectStartPage: `${window.location.origin}/`,
    }).catch(() => {
      startedRef.current = false;
      setError("Account registration could not be started. Please refresh this page and try again.");
    });
  }, [inProgress, instance, isAuthenticated]);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (error) {
    return (
      <WorkspaceLoading
        title="Registration could not be started"
        message={error}
      />
    );
  }

  return (
    <WorkspaceLoading
      title="Opening account registration..."
      message="You will be redirected to Microsoft to create your Land Agility account."
    />
  );
};

export default RegisterRedirect;
